import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  flagsResourceSuccess,
  flagsResourceFailure,
  flagsResourceRequest,
} = createActions(
  'FLAGS_RESOURCE_SUCCESS',
  'FLAGS_RESOURCE_FAILURE',
  'FLAGS_RESOURCE_REQUEST',
);

const requestFlagOptions = () => (dispatch) => {
  dispatch(flagsResourceRequest());
  return request('flags')
    .then(({ json }) => dispatch(flagsResourceSuccess(json)))
    .catch(error => dispatch(flagsResourceFailure(error)));
};

export default requestFlagOptions;




// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/flags.js